import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import { IJob2s } from '../../../redux/progress/job2/job2Interface';
import { IState } from '../../../redux/store';
import { startMonitor, stopMonitor } from '../../../service/jobMonitorService';
import { job2update } from '../../../redux/progress/job2/job2Action';


function Monitor(props: {
    userName: string,
    activeProjectName: string,
    lineName: string,
    job2update: (jobs: IJob2s) => void
}) {

    const { spec, tech } = useParams<{ spec: string, tech: string }>();
    
    useEffect(() => {
        if (props.lineName) {
            startMonitor(props.userName, props.activeProjectName, props.lineName, spec, tech);
        } else {
            props.job2update({});
        }
        return stopMonitor;
    }, [props.userName, props.activeProjectName, props.lineName, spec, tech]); // eslint-disable-line
    return <></>
}

const mapStateToProps = (state: IState) => {
    return {
        userName: state.user.userName,
        activeProjectName: state.project.activeName,
        lineName: state.progress.line.activeName
    };
};

export default connect(
    mapStateToProps,
    { job2update }
)(Monitor);